<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Profil -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-12 col-xl-9">
                        <h2>Náš profil</h2>

                        <aside v-if="profil.pouzivatel_id && profil.pouzivatel_id.pouzivatel_group === 1" class="mb-30 rounded-10 main-banner position-relative">
                            <img src="assets/img/skolska-sekcia-bg.png" alt="" class="img-fluid">
                            <div class="position-absolute">
                                <span class="badge-pill --success mb-20">Nová školská súťaž</span>
                                <h2 class="mb-20">Poďte súťažiť o <br>super ceny</h2>
                                <router-link to="/skoly" class="btn --primary">Chceme súťažiť</router-link>
                            </div>
                        </aside>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Založiť farmu -->
<!--                        <span v-if="profil.pouzivatel_id.farma_pouzivatela.length == 0 && profil.pouzivatel_id.kravicky_pouzivatela.length > 0">-->
<!--                            <router-link :to="{ name: 'vytvorenie-farmy' }">-->
<!--                                <img class="img-fluid mb-3 main-banner" src="assets/img/banner.png">-->
<!--                            </router-link>-->
<!--                        </span>-->

                        <!-- Banner -->
                        <!--<a target="_blank" href="https://www.adoptujkravicku.sk/hrat-sa-odteraz-oplati-este-viac/">
                            <img class="img-fluid mb-3 main-banner --rounded --wShadow" src="assets/img/banner-dukaty.jpg">
                        </a>-->

                        <div class="row">

                            <!-- Box 1 - Album -->
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div class="m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3">

                                    <h5 class="a-profileCard__title">Náš album</h5>
                                    <div class="a-profileCard__value">{{ albumProgress }}</div>
                                    <div class="a-profileCard__description">odomknutých súčastí</div>
                                    <div class="a-profileCard__button">
                                        <router-link :to="{ name: 'album' }" class="btn --primary">
                                            Náš album
                                        </router-link>
                                    </div>

                                </div>
                            </div>
                            <!-- .Box 1 -->

                            <!-- Box 2 - Kravičky -->
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div class="m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3">

                                    <h5 class="a-profileCard__title">Naša kravička</h5>
                                    <div class="a-profileCard__value">{{ profil.pouzivatel_id.kravicky_pouzivatela.length }}</div>
                                    <div class="a-profileCard__description">

                                        <!-- Skloňovanie -->
                                        <span v-if="profil.pouzivatel_id.kravicky_pouzivatela.length == 1">
                                            adoptovaná kravička
                                        </span>
                                        <span v-else-if="profil.pouzivatel_id.kravicky_pouzivatela.length > 1 && profil.pouzivatel_id.kravicky_pouzivatela.length < 5">
                                            adoptované kravičky
                                        </span>
                                        <span v-else>
                                            adoptovaných kravičiek
                                        </span>
                                        <!-- .Skloňovanie -->

                                    </div>
                                    <div class="a-profileCard__button">
                                        <router-link :to="{ name: 'kravicky' }" class="btn --primary">
                                            Naša kravička
                                        </router-link>
                                    </div>

                                </div>
                            </div>
                            <!-- .Box 2 -->

                            <!-- Box 3 - Správy -->
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div class="m-profileCard mb-lg-3 mb-md-3 mb-sm-3 mb-3">

                                    <h5 class="a-profileCard__title">Naše správy</h5>
                                    <div class="a-profileCard__value">{{ spravy }}</div>
                                    <div class="a-profileCard__description">

                                        <!-- Skloňovanie -->
                                        <span v-if="spravy == 1">
                                            neprečítaná správa
                                        </span>
                                        <span v-else-if="spravy > 1 && spravy < 5">
                                            neprečítané správy
                                        </span>
                                        <span v-else>
                                            neprečítaných správ
                                        </span>
                                        <!-- .Skloňovanie -->

                                    </div>
                                    <div class="a-profileCard__button">
                                        <router-link :to="{ name: 'spravy' }" class="btn --primary">
                                            Naše správy
                                        </router-link>
                                    </div>

                                </div>
                            </div>
                            <!-- .Box 3 -->

                        </div>

                    </div>
                    <!-- .Profil -->

                </div>

            </div>

        </main>
        <!-- .Main -->

        <div v-if="showRuleta">
            <ruleta
                @updateProfil="emitUpdateProfil"
                :profil="profil"
            />
        </div>

    </div>

</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    import Ruleta       from '../partials/Ruleta.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil,
            // Roulette,
            Ruleta
        },
        props: [
            'profil',
            'spravy',
        ],
        mounted() {
            //this.checkUspechy()
            this.getAlbumProgress()
            this.getRuletaLog()
        },
        updated() {
            if (this.updated == 0) {
                this.checkUspechy()
            }
        },
        data() {
            return {
                albumProgress: '0/0',
                showRuleta: false,

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            checkUspechy() {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1
                    this.getKravicky100PercentneStastne3DniPoSebe()
                }
            },

            getAlbumProgress() {
                EventService.getAlbumProgress()
                    .then(response => {
                        //console.log(response.data)

                        //var x = response.data.data.toString()
                        //this.albumProgress = x.substring(0, 5)
                        this.albumProgress = response.data.data
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            getRuletaLog() {
                EventService.getRuletaLog()
                    .then(response => {
                        //console.log(response.data)
                        if (typeof(response.data.data[0]) == 'undefined') {
                            this.showRuleta = true
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            getKravicky100PercentneStastne3DniPoSebe() {

                EventService.getAchievementStastneKravicky(this.profil.pouzivatel_id.id)
                    .then( response => {

                        if (response.data.data === true ) {

                            //var key = EventService.checkAchievementProgress(this.profil, 2)
                            var key = EventService.checkAchievementProgress(this.profil, 13)

                            if (key > -2) {

                                //EventService.setAchievementProgress(this.profil, 2)
                                EventService.setAchievementProgress(this.profil, 13)
                                    .then(response => {
                                        //console.log(response.data)
                                        //this.responseType = response.data.code
                                        //this.responseText = response.data.data

                                        sessionStorage.setItem("album-uspechy", "refresh")

                                        if (key == -1) {
                                            this.$emit('updateProfil')
                                        } else {
                                            this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                            this.$emit('update:profil', this.profil)
                                        }

                                        // achievements toast popup
                                        this.$toast.success(' ', response.data.data)

                                    })
                                    .catch(error => {
                                        this.responseType = 'warning'
                                        this.responseText = error
                                    })

                            }

                        }

                    })
            }
        }
    }
</script>
